/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { ComponentType, FunctionComponent } from 'react';
import { IDataError } from '@forge/data-connector';
import './MSErrorStatus.scss';
import { ErrorContainer } from '@bmsp/bmsp.web.component.common';
import { apiNoContentStatusCode } from '../Utils/Constants';
import { ISiteCard } from '../../DashboardKPIWidgets/IEnergyManagementProps';

export interface IErrorStatusProps extends ISiteCard {
  error: IDataError;
  title?: string;
  noDataMessage: string;
  connectionErrorMessage: string;
  statusCode?: number | null;
  hideNoData?: boolean;
  isNoContent?: boolean;
}

const withMSErrorStatus = <P extends Object>(
  WrappedComponent: ComponentType<P>
): FunctionComponent<P & IErrorStatusProps> =>
  React.memo(
    ({
      error,
      title,
      noDataMessage,
      connectionErrorMessage,
      onRefresh,
      statusCode,
      hideNoData,
      isNoContent,
      ...props
    }: IErrorStatusProps) => {
      const status =
        statusCode ??
        (error ? error.status ?? error.rawResponse?.response?.status : null);
      if (status === apiNoContentStatusCode && !hideNoData) {
        if (isNoContent)
          return (
            <div className="noDataDisplay ms-common-error-container">
              <div className="error-block">
                <div className="heading">
                  No data available for selected date period
                </div>
              </div>
            </div>
          );

        return (
          <div className="noDataDisplay ms-common-error-container">
            <ErrorContainer
              //statusCode={statusCode ?? undefined}
              headerText={'No data available for selected date period'}
              errorDescription={' '}
            />
          </div>
        );
      }
      const errorCheck = (
        arg1: string | null,
        arg2: number | null,
        arg3: string | null
      ) => {
        if (arg1 || arg2 || arg3) {
          return true;
        } else return false;
      };

      if (
        error &&
        (errorCheck(error.name, error.status, error.message) ||
          error.rawResponse)
      ) {
        return (
          <div className="errorDisplay ms-common-error-container">
            <ErrorContainer
              headerText={'Loading Error'}
              errorDescription={
                'Refresh the page to load the data. Contact your administrator if the problem persists.'
              }
            />
          </div>
        );
      }

      return (
        <WrappedComponent
          {...(props as P)}
          title={title}
          onRefresh={onRefresh}
          statusCode={statusCode}
        />
      );
    }
  );

export default withMSErrorStatus;
